var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17,
    stroke: "#1A1818",
    strokeOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7224 17.5L12.1613 12.94C12.1101 12.8888 12.0696 12.8281 12.0419 12.7613C12.0142 12.6945 12 12.6229 12 12.5506C12 12.4783 12.0142 12.4067 12.0419 12.3399C12.0696 12.2731 12.1101 12.2124 12.1613 12.1613C12.2124 12.1101 12.2731 12.0696 12.3399 12.0419C12.4067 12.0142 12.4783 12 12.5506 12C12.6229 12 12.6945 12.0142 12.7613 12.0419C12.8281 12.0696 12.8888 12.1101 12.94 12.1613L17.5 16.7224L22.06 12.1613C22.1633 12.058 22.3033 12 22.4494 12C22.5954 12 22.7355 12.058 22.8387 12.1613C22.942 12.2645 23 12.4046 23 12.5506C23 12.6967 22.942 12.8367 22.8387 12.94L18.2776 17.5L22.8387 22.06C22.942 22.1633 23 22.3033 23 22.4494C23 22.5954 22.942 22.7355 22.8387 22.8387C22.7355 22.942 22.5954 23 22.4494 23C22.3033 23 22.1633 22.942 22.06 22.8387L17.5 18.2776L12.94 22.8387C12.8367 22.942 12.6967 23 12.5506 23C12.4046 23 12.2645 22.942 12.1613 22.8387C12.058 22.7355 12 22.5954 12 22.4494C12 22.3033 12.058 22.1633 12.1613 22.06L16.7224 17.5Z",
    fill: "#1A1818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.2d0f95695c31cc853108fc3f7507a8da.svg";
export { ForwardRef as ReactComponent };